// @flow
import shortId from 'shortid'
import store from '../../store'
import type { InputCarousel, CarouselErrors } from '../../../components/types'
import { init, patch } from './reducers'
import { putMedia } from '../media/operations'
import getDefaultCrop from '../../../components/getDefaultCrop'
import _ from 'lodash'
import { getCarousel, hasCarouselCardAnyErrors } from '../../selectors'
import type { CarouselCard } from './reducers'
import { singleCrop } from '../AdvertisementDataAdapter'

const t = {
  cards_have_errors: 'некоторые карточки имеют некорректные данные'
}

export function putCarousel(carousel: InputCarousel): string {
  const storeId = shortId.generate()
  store.dispatch(
    init(storeId, {
      currentCardIndex: 0,
      cards: _.map(carousel.cards, (card) => {
        const cardImage = card.image
        return {
          url: card.url,
          title: card.title,
          description: card.description,
          imageStoreId: cardImage && putMedia(cardImage),
          crop:
            cardImage &&
            (singleCrop(card.image_crop) || getDefaultCrop(cardImage.width, cardImage.height, 1.0)),
          vkLinkButton: card.vk_link_button || '',
          price: card.price || '',
          oldPrice: card.old_price || '',
          urlErrors: [],
          titleErrors: [],
          descriptionErrors: [],
          imageErrors: [],
          vkLinkButtonErrors: [],
          priceErrors: [],
          oldPriceErrors: []
        }
      }),
      errors: []
    })
  )
  return storeId
}

export function putErrors(storeId: string, errors: CarouselErrors) {
  if (_.isEmpty(errors)) return
  const errorsWithoutType = (errors: any)

  let mainErrors = []
  const carousel = getCarousel(store.getState(), storeId)
  let cards = carousel.cards
  let currentCardIndex = carousel.currentCardIndex
  if (_.isArray(errors)) {
    mainErrors = errorsWithoutType
    cards = clearCardErrors(cards)
  } else if (errorsWithoutType && _.isArray(errorsWithoutType.cards)) {
    const cardsErrors = errorsWithoutType.cards
    if (typeof cardsErrors[0] === 'string') {
      mainErrors = cardsErrors
      cards = clearCardErrors(cards)
    } else {
      cards = _.map(cards, (card: CarouselCard, index: number) => {
        const cardErrors = cardsErrors[index]
        return {
          ...card,
          urlErrors: cardErrors.url || [],
          titleErrors: cardErrors.title || [],
          descriptionErrors: cardErrors.description || [],
          imageErrors: cardErrors.image_id || [],
          vkLinkButtonErrors: cardErrors.vk_link_button || [],
          priceErrors: cardErrors.price || [],
          oldPriceErrors: cardErrors.old_price || []
        }
      })
      const cardIndexWithErrors = _.findIndex(cards, (card) => hasCarouselCardAnyErrors(card))
      if (cardIndexWithErrors !== -1) {
        mainErrors = [t.cards_have_errors]
        currentCardIndex = cardIndexWithErrors
      }
    }
  }
  store.dispatch(patch(storeId, { cards, errors: mainErrors, currentCardIndex }))
}

function clearCardErrors(cards) {
  return _.map(cards, (card: CarouselCard) => {
    return {
      ...card,
      urlErrors: [],
      titleErrors: [],
      descriptionErrors: [],
      imageErrors: [],
      vkLinkButtonErrors: [],
      priceErrors: [],
      oldPriceErrors: []
    }
  })
}
